/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelSubscriptionRequest,
  ChargeInvoice200Response,
  CreateOrganization400Response,
  CreateSaveCardSession200Response,
  CreateSaveCardSessionRequest,
  GetBillingDetails200Response,
  GetBillingDetails200ResponseTax,
  GetCardChallenge200Response,
  GetCardChallengeRequest,
  GetInstallationPricing200Response,
  GetLocationSubscription200Response,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  GetReservationsFeatures200Response,
  GetReservationsSubscription200Response,
  GetSavedPaymentMethod200Response,
  GetSavedPaymentMethodRequest,
  GetSubscriptionConfig200Response,
  GetSubscriptionUsage200Response,
  ListInvoices200Response,
  ListInvoices200ResponseItemsInner,
  SubmitCardChallenge400Response,
  SubmitCardChallengeRequest,
  UpdateLocationSubscriptionRequest,
  UpdatePlanRequest,
  UpdateReservationsSubscriptionRequest,
} from '../models/index';
import {
    CancelSubscriptionRequestFromJSON,
    CancelSubscriptionRequestToJSON,
    ChargeInvoice200ResponseFromJSON,
    ChargeInvoice200ResponseToJSON,
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    CreateSaveCardSession200ResponseFromJSON,
    CreateSaveCardSession200ResponseToJSON,
    CreateSaveCardSessionRequestFromJSON,
    CreateSaveCardSessionRequestToJSON,
    GetBillingDetails200ResponseFromJSON,
    GetBillingDetails200ResponseToJSON,
    GetBillingDetails200ResponseTaxFromJSON,
    GetBillingDetails200ResponseTaxToJSON,
    GetCardChallenge200ResponseFromJSON,
    GetCardChallenge200ResponseToJSON,
    GetCardChallengeRequestFromJSON,
    GetCardChallengeRequestToJSON,
    GetInstallationPricing200ResponseFromJSON,
    GetInstallationPricing200ResponseToJSON,
    GetLocationSubscription200ResponseFromJSON,
    GetLocationSubscription200ResponseToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    GetReservationsFeatures200ResponseFromJSON,
    GetReservationsFeatures200ResponseToJSON,
    GetReservationsSubscription200ResponseFromJSON,
    GetReservationsSubscription200ResponseToJSON,
    GetSavedPaymentMethod200ResponseFromJSON,
    GetSavedPaymentMethod200ResponseToJSON,
    GetSavedPaymentMethodRequestFromJSON,
    GetSavedPaymentMethodRequestToJSON,
    GetSubscriptionConfig200ResponseFromJSON,
    GetSubscriptionConfig200ResponseToJSON,
    GetSubscriptionUsage200ResponseFromJSON,
    GetSubscriptionUsage200ResponseToJSON,
    ListInvoices200ResponseFromJSON,
    ListInvoices200ResponseToJSON,
    ListInvoices200ResponseItemsInnerFromJSON,
    ListInvoices200ResponseItemsInnerToJSON,
    SubmitCardChallenge400ResponseFromJSON,
    SubmitCardChallenge400ResponseToJSON,
    SubmitCardChallengeRequestFromJSON,
    SubmitCardChallengeRequestToJSON,
    UpdateLocationSubscriptionRequestFromJSON,
    UpdateLocationSubscriptionRequestToJSON,
    UpdatePlanRequestFromJSON,
    UpdatePlanRequestToJSON,
    UpdateReservationsSubscriptionRequestFromJSON,
    UpdateReservationsSubscriptionRequestToJSON,
} from '../models/index';

export interface CancelSubscriptionOperationRequest {
    cancelSubscriptionRequest: CancelSubscriptionRequest;
}

export interface ChargeInvoiceRequest {
    invoiceId: string;
}

export interface CreateSaveCardSessionOperationRequest {
    createSaveCardSessionRequest: CreateSaveCardSessionRequest;
}

export interface DownloadInvoiceRequest {
    invoiceId: string;
}

export interface DownloadInvoicesRequest {
    invoiceIds: Array<string>;
}

export interface GetCardChallengeOperationRequest {
    getCardChallengeRequest: GetCardChallengeRequest;
}

export interface GetInstallationPricingRequest {
    selectedPlan: GetInstallationPricingSelectedPlanEnum;
}

export interface GetInvoiceRequest {
    invoiceId: string;
}

export interface GetLocationPlansRequest {
    countryCode?: GetLocationPlansCountryCodeEnum;
}

export interface GetReservationsPlansRequest {
    countryCode?: string;
}

export interface GetSavedPaymentMethodOperationRequest {
    getSavedPaymentMethodRequest: GetSavedPaymentMethodRequest;
}

export interface GetTaxRateRequest {
    countryCode: string;
    regionCode?: string;
}

export interface ListInvoicesRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface SubmitCardChallengeOperationRequest {
    submitCardChallengeRequest: SubmitCardChallengeRequest;
}

export interface UpdateLocationSubscriptionOperationRequest {
    updateLocationSubscriptionRequest: UpdateLocationSubscriptionRequest;
}

export interface UpdatePlanOperationRequest {
    updatePlanRequest: UpdatePlanRequest;
}

export interface UpdateReservationsSubscriptionOperationRequest {
    updateReservationsSubscriptionRequest: UpdateReservationsSubscriptionRequest;
}

/**
 * 
 */
export class InternalBillingApi extends runtime.BaseAPI {

    /**
     */
    async cancelSubscriptionRaw(requestParameters: CancelSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['cancelSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'cancelSubscriptionRequest',
                'Required parameter "cancelSubscriptionRequest" was null or undefined when calling cancelSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/cancel`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CancelSubscriptionRequestToJSON(requestParameters['cancelSubscriptionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelSubscription(requestParameters: CancelSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async chargeInvoiceRaw(requestParameters: ChargeInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChargeInvoice200Response>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling chargeInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/{invoiceId}/charge`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChargeInvoice200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async chargeInvoice(requestParameters: ChargeInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChargeInvoice200Response> {
        const response = await this.chargeInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSaveCardSessionRaw(requestParameters: CreateSaveCardSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSaveCardSession200Response>> {
        if (requestParameters['createSaveCardSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'createSaveCardSessionRequest',
                'Required parameter "createSaveCardSessionRequest" was null or undefined when calling createSaveCardSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/payment/save-card-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSaveCardSessionRequestToJSON(requestParameters['createSaveCardSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSaveCardSession200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSaveCardSession(requestParameters: CreateSaveCardSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSaveCardSession200Response> {
        const response = await this.createSaveCardSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadInvoiceRaw(requestParameters: DownloadInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling downloadInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/{invoiceId}/download`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadInvoice(requestParameters: DownloadInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadInvoicesRaw(requestParameters: DownloadInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['invoiceIds'] == null) {
            throw new runtime.RequiredError(
                'invoiceIds',
                'Required parameter "invoiceIds" was null or undefined when calling downloadInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['invoiceIds'] != null) {
            queryParameters['invoiceIds'] = requestParameters['invoiceIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/bulk`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadInvoices(requestParameters: DownloadInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBillingDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingDetails200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/billing-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingDetails200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBillingDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingDetails200Response> {
        const response = await this.getBillingDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCardChallengeRaw(requestParameters: GetCardChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCardChallenge200Response>> {
        if (requestParameters['getCardChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'getCardChallengeRequest',
                'Required parameter "getCardChallengeRequest" was null or undefined when calling getCardChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/payment/card`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCardChallengeRequestToJSON(requestParameters['getCardChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCardChallenge200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCardChallenge(requestParameters: GetCardChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCardChallenge200Response> {
        const response = await this.getCardChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInstallationPricingRaw(requestParameters: GetInstallationPricingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInstallationPricing200Response>> {
        if (requestParameters['selectedPlan'] == null) {
            throw new runtime.RequiredError(
                'selectedPlan',
                'Required parameter "selectedPlan" was null or undefined when calling getInstallationPricing().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['selectedPlan'] != null) {
            queryParameters['selectedPlan'] = requestParameters['selectedPlan'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/installation-price`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInstallationPricing200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInstallationPricing(requestParameters: GetInstallationPricingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInstallationPricing200Response> {
        const response = await this.getInstallationPricingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvoiceRaw(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvoices200ResponseItemsInner>> {
        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling getInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvoices200ResponseItemsInnerFromJSON(jsonValue));
    }

    /**
     */
    async getInvoice(requestParameters: GetInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvoices200ResponseItemsInner> {
        const response = await this.getInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationPlansRaw(requestParameters: GetLocationPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/location/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getLocationPlans(requestParameters: GetLocationPlansRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getLocationPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationSubscription200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/location/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationSubscription200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationSubscription200Response> {
        const response = await this.getLocationSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationsFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationsFeatures200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reservation/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationsFeatures200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationsFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationsFeatures200Response> {
        const response = await this.getReservationsFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationsPlansRaw(requestParameters: GetReservationsPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reservation/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getReservationsPlans(requestParameters: GetReservationsPlansRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getReservationsPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationsSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationsSubscription200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reservation/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationsSubscription200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationsSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationsSubscription200Response> {
        const response = await this.getReservationsSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSavedPaymentMethodRaw(requestParameters: GetSavedPaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSavedPaymentMethod200Response>> {
        if (requestParameters['getSavedPaymentMethodRequest'] == null) {
            throw new runtime.RequiredError(
                'getSavedPaymentMethodRequest',
                'Required parameter "getSavedPaymentMethodRequest" was null or undefined when calling getSavedPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/payment/saved-payment-method`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSavedPaymentMethodRequestToJSON(requestParameters['getSavedPaymentMethodRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSavedPaymentMethod200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSavedPaymentMethod(requestParameters: GetSavedPaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSavedPaymentMethod200Response> {
        const response = await this.getSavedPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubscriptionConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubscriptionConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionConfig200Response> {
        const response = await this.getSubscriptionConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubscriptionUsageRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionUsage200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionUsage200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubscriptionUsage(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionUsage200Response> {
        const response = await this.getSubscriptionUsageRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTaxRateRaw(requestParameters: GetTaxRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingDetails200ResponseTax>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getTaxRate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['regionCode'] != null) {
            queryParameters['regionCode'] = requestParameters['regionCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/taxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingDetails200ResponseTaxFromJSON(jsonValue));
    }

    /**
     */
    async getTaxRate(requestParameters: GetTaxRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingDetails200ResponseTax> {
        const response = await this.getTaxRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listInvoicesRaw(requestParameters: ListInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvoices200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvoices200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async listInvoices(requestParameters: ListInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvoices200Response> {
        const response = await this.listInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reactivateSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reactivate`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reactivateSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reactivateSubscriptionRaw(initOverrides);
    }

    /**
     */
    async retryPaymentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/invoice/retry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async retryPayment(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryPaymentRaw(initOverrides);
    }

    /**
     */
    async submitCardChallengeRaw(requestParameters: SubmitCardChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['submitCardChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'submitCardChallengeRequest',
                'Required parameter "submitCardChallengeRequest" was null or undefined when calling submitCardChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/payment/card/challenge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitCardChallengeRequestToJSON(requestParameters['submitCardChallengeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async submitCardChallenge(requestParameters: SubmitCardChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitCardChallengeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationSubscriptionRaw(requestParameters: UpdateLocationSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateLocationSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationSubscriptionRequest',
                'Required parameter "updateLocationSubscriptionRequest" was null or undefined when calling updateLocationSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/location/subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationSubscriptionRequestToJSON(requestParameters['updateLocationSubscriptionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationSubscription(requestParameters: UpdateLocationSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePlanRaw(requestParameters: UpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePlanRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePlanRequest',
                'Required parameter "updatePlanRequest" was null or undefined when calling updatePlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanRequestToJSON(requestParameters['updatePlanRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePlan(requestParameters: UpdatePlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateReservationsSubscriptionRaw(requestParameters: UpdateReservationsSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateReservationsSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReservationsSubscriptionRequest',
                'Required parameter "updateReservationsSubscriptionRequest" was null or undefined when calling updateReservationsSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/internal-billing/reservation/subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReservationsSubscriptionRequestToJSON(requestParameters['updateReservationsSubscriptionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservationsSubscription(requestParameters: UpdateReservationsSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationsSubscriptionRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetInstallationPricingSelectedPlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type GetInstallationPricingSelectedPlanEnum = typeof GetInstallationPricingSelectedPlanEnum[keyof typeof GetInstallationPricingSelectedPlanEnum];
/**
 * @export
 */
export const GetLocationPlansCountryCodeEnum = {
    Es: 'ES',
    Mx: 'MX',
    Ad: 'AD',
    De: 'DE',
    Pe: 'PE',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL'
} as const;
export type GetLocationPlansCountryCodeEnum = typeof GetLocationPlansCountryCodeEnum[keyof typeof GetLocationPlansCountryCodeEnum];
